export const CANTRATE_ID = 123456789;
